if (!customElements.get('mv-deals-v2-card')) {
  customElements.define('mv-deals-v2-card', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.optionIndex = Number(this.dataset.optionIndex);
      this.moneyFormat = this.dataset.moneyFormat || '\${{amount}}';
      this.idInput = this.querySelector('[data-dv2-id]');
      this.price = this.querySelector('[data-dv2-price]');
      this.compare = this.querySelector('[data-dv2-compare]');
      this.savings = this.querySelector('[data-dv2-save]');
      this.image = this.querySelector('.mv-deals-v2-card__image');
      this.add = this.querySelector('[data-dv2-add]');
      this.label = this.querySelector('[data-dv2-label]');
      this.message = this.querySelector('[data-dv2-message]');
      try { this.variants = JSON.parse(this.querySelector('[data-dv2-variants]').textContent); } catch (_) { this.variants = []; }
      this.querySelectorAll('[data-dv2-option]').forEach(button => button.addEventListener('click', () => this.select(button)));
      this.querySelector('[data-dv2-form]')?.addEventListener('submit', event => this.submit(event));
    }
    money(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents, this.moneyFormat);
      return this.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, (Number(cents || 0) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
    }
    select(button) {
      const value = button.dataset.dv2Option;
      const current = this.variants.find(v => v.id === Number(this.idInput.value));
      let variant = this.variants.find(v => v.available && v.options[this.optionIndex] === value && (!current || v.options.every((o, i) => i === this.optionIndex || o === current.options[i])));
      if (!variant) variant = this.variants.find(v => v.available && v.options[this.optionIndex] === value);
      if (!variant) return;
      this.querySelectorAll('[data-dv2-option]').forEach(item => {
        const selected = item === button;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', String(selected));
      });
      this.idInput.value = variant.id;
      this.price.textContent = this.money(variant.price);
      const sale = variant.compare_at_price && variant.compare_at_price > variant.price;
      this.compare.hidden = !sale;
      this.compare.textContent = sale ? this.money(variant.compare_at_price) : '';
      this.savings.hidden = !sale;
      this.savings.textContent = sale ? 'Save ' + this.money(variant.compare_at_price - variant.price).replace(/\.00(?=\D*$)/, '') : '';
      this.add.disabled = !variant.available;
      this.label.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (this.image && variant.featured_image?.src) {
        this.image.src = variant.featured_image.src;
        this.image.removeAttribute('srcset');
      }
      this.message.hidden = true;
    }
    async submit(event) {
      event.preventDefault();
      if (this.add.disabled) return;
      const old = this.label.textContent;
      this.add.disabled = true;
      this.label.textContent = 'Adding…';
      this.message.hidden = true;
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(this.idInput.value), quantity: 1 }] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add this item.');
        this.add.classList.add('is-added');
        this.label.textContent = 'Added to cart';
        this.message.innerHTML = '<a href="/cart">View cart</a>';
        this.message.hidden = false;
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: result } }));
        setTimeout(() => {
          this.add.classList.remove('is-added');
          this.add.disabled = false;
          this.label.textContent = old;
        }, 2200);
      } catch (error) {
        this.message.textContent = error.message || 'Unable to add this item.';
        this.message.hidden = false;
        this.add.disabled = false;
        this.label.textContent = old;
      }
    }
  });
}
